'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

exports.BrandStyleAttributeValueType = void 0;
(function (BrandStyleAttributeValueType) {
    BrandStyleAttributeValueType["Rem"] = "rem";
    BrandStyleAttributeValueType["Px"] = "px";
    BrandStyleAttributeValueType["Text"] = "text";
    BrandStyleAttributeValueType["Number"] = "number";
    BrandStyleAttributeValueType["ColorReference"] = "color_reference";
    BrandStyleAttributeValueType["FontReference"] = "font_reference";
    BrandStyleAttributeValueType["FontVariantReference"] = "font_variant_reference";
})(exports.BrandStyleAttributeValueType || (exports.BrandStyleAttributeValueType = {}));
exports.BrandFontType = void 0;
(function (BrandFontType) {
    BrandFontType["Custom"] = "custom";
    BrandFontType["Google"] = "google";
})(exports.BrandFontType || (exports.BrandFontType = {}));
//# sourceMappingURL=brand.js.map
